<template>
  <v-container fluid>
    <!-- Encabezado y acción principal -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="pa-6 elevation-2 rounded-xl">
          <v-card-title class="headline font-weight-light text-center mb-2">
            Registro de Asistencia
          </v-card-title>
          <v-card-subtitle class="text-center mb-4">
            ¡Hola! Da clic en el botón para registrar tu asistencia del día.
          </v-card-subtitle>

          <div class="text-center">
            <v-btn color="primary" large class="mb-4" @click="registrar">
              <v-icon left>mdi-check-circle</v-icon>
              Registrar asistencia
            </v-btn>
          </div>
          <v-divider class="my-4"></v-divider>
          <v-data-table dense fixed-header height="300px" :headers="headers" :items="listado" :search="search"
            item-key="Id" class="elevation-1 rounded-lg">
            <template v-slot:no-data>
              <v-alert type="info" text>
                No se encontraron registros de asistencia.
              </v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      search: '',
      listado: [],
      headers: [
        // { text: 'ID', value: 'Id' },
        { text: 'Fecha ', value: 'FechaRegistroFormat' },
        { text: 'Hora', value: 'HoraRegistroFormat' }
      ],
      isEntrada: false,
      isSalida: false
    }
  },
  computed: {
    ...mapGetters(['getIDE'])
  },
  created() {
    this.getAsistencia()
  },
  methods: {
     registrar() {
      this.$http.post(`Asistencia`,
        {
          idUser: this.getIDE
        })
        .then(response => {
          if (response.status === 200) {
            this.$swal.fire({
              position: 'center',
              icon: 'success',
              title: response.data,
              showConfirmButton: false,
              timer: 1500,
              backdrop: false
            })
            this.getAsistencia()

          } else {
            console.error('Error al obtener asistencia:', response)
          }
        })
        .catch((error) => {
          console.error('Error al consultar asistencia:', error)
        });
    },
    getAsistencia() {
      this.$http.get(`Asistencia/${this.getIDE}`)
        .then(response => {
          if (response.status === 200) {
            this.listado = response.data

          } else {
            console.error('Error al obtener asistencia:', response)
          }
        })
        .catch((error) => {
          console.error('Error al consultar asistencia:', error)
        });
    }
  }
}
</script>

<style scoped>
.v-card {
  background: #fdfdfd;
}
</style>
